import { memo } from 'react';
import type { FC } from 'react';
import Picture from '../Picture';
import {
  promocodeBannerAvocado,
  promocodeBannerFish,
  promocodeBannerMusseles,
  promocodeBannerLeaf,
  promocodeBannerOyster,
  promocodeBanneroBroccoli
} from '@images';
import './PromocodeBanner.scss';

const imagesList = [
  {
    id: 0,
    image: promocodeBannerAvocado,
    width: '214',
    height: '193',
    className: 'promocode-banner__avocado'
  },
  {
    id: 1,
    image: promocodeBannerFish,
    width: '385',
    height: '401',
    className: 'promocode-banner__fish'
  },
  {
    id: 2,
    image: promocodeBannerMusseles,
    width: '203',
    height: '162',
    className: 'promocode-banner__musseles'
  },
  {
    id: 3,
    image: promocodeBannerLeaf,
    width: '83',
    height: '82',
    className: 'promocode-banner__leaf'
  },
  {
    id: 4,
    image: promocodeBannerOyster,
    width: '206',
    height: '196',
    className: 'promocode-banner__oyster'
  },
  {
    id: 5,
    image: promocodeBanneroBroccoli,
    width: '197',
    height: '242',
    className: 'promocode-banner__broccoli'
  }
];

const PromocodeBanner: FC = () => (
  <div className='promocode-banner '>
    {imagesList.map(({ id, height, image, width, className }) => (
      <Picture
        key={id}
        icon={image}
        width={width}
        height={height}
        pictureClassName={className}
      />
    ))}
    <div className='promocode-banner__title'>
      Дарим 200 ₽ <br /> и бесплатную доставку
    </div>
    <div className='promocode-banner__sub-title'>
      Промокод <span className='promocode-banner__sub-title__code'>NEW200</span>{' '}
      <br />
      на первый заказ
    </div>
  </div>
);

export default memo(PromocodeBanner);
